<app-change-order-client
    [placeholder]="useClientType === 'creditor' ? 'Indtast leverandørnummer' : 'Indtast debitornummer'"
    [clientType]="useClientType"
    [customListIcon]="selectIcon"
    [selectedIcon]="selectedIcon"
    [doNotFilterSelected]="true"
    (didChangeClient)="onChangeClient($event)"
></app-change-order-client>
